import React, { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

const ConvertToCustomerModal = ({ user, onClose }) => {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      await axios.post('/api/promotion-requests/convert-to-customer');
      
      setSuccess(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      console.error('Failed to submit convert to customer request:', error);
      setError(error.response?.data?.message || t('Failed to submit request. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
            <h3 style={{ color: 'var(--dark-blue)', marginBottom: '15px' }}>
              {t('Conversion Request Submitted!')}
            </h3>
            <p style={{ color: 'var(--gray-dark)' }}>
              {t('Your request has been sent to the Upline Tab Team for approval.')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{t('Convert To Customer')}</h3>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        {error && (
          <div className="alert alert-error">{error}</div>
        )}

        <div style={{ padding: '30px' }}>
          <div style={{
            background: 'var(--pale-blue)',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '2px solid var(--primary-blue)'
          }}>
            <h4 style={{ color: 'var(--dark-blue)', marginBottom: '15px' }}>
              {t('Transition From Coach to Customer')}
            </h4>
            <p style={{ fontSize: '14px', color: 'var(--gray-dark)', marginBottom: '15px' }}>
              {t('This request will be sent to the Upline Tab Team for approval. Once approved:')}
            </p>
            <ul style={{ fontSize: '14px', color: 'var(--gray-dark)', marginLeft: '20px' }}>
              <li>{t('Your role will be changed from Coach to Customer')}</li>
              <li>{t('You will lose access to coach features and tools')}</li>
              <li>{t('Your immediate customers will be moved to your parent coach')}</li>
              <li>{t('You will become a customer under your parent coach')}</li>
              <li>{t('This action can be reversed with another promotion request')}</li>
            </ul>
          </div>

          <div style={{
            background: '#FFF3CD',
            border: '1px solid #FFEAA7',
            padding: '15px',
            borderRadius: '6px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            <strong>{t('Important')}:</strong> {t('This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed. This action will significantly change your account permissions.')}
          </div>

          <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              {t('Cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
              style={{ 
                background: 'var(--warning)',
                border: 'none'
              }}
            >
              {loading ? t('Submitting...') : t('Submit Request')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvertToCustomerModal;
